<template>
    <div class="about">
        <Menu/>
        <div class="banner">
            <b-container>
                <b-row>
                    <b-col md="8" offset-md="2">
                        <h3 class="mb-3">Tenemos un gran sueño. Convertirnos en la mejor compañía de lentes de sol en México.</h3>
                        <p>Soñamos con tener un mundo mejor. Y de la mano de nuestros colaboradores, queremos lograrlo ofreciendo productos de calidad y a la moda, siempre con un servicio excepcional, a un costo accesible. Nuestra pasión es iluminar las vidas de nuestros clientes, haciéndoles sentir especiales en cada compra.</p>
                        <img class="img-fluid" src="" alt="">
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12" class="wrapper-video">
                        <video muted playsinline autoplay loop>
                            <source src="../assets/video_conocenos.mp4" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="valores">
            <b-container>
                <b-row>
                    <b-col class="text-center mb-3" md="12">
                        <span class="hightlight">Nuestros valores</span>
                        <h3 class="mb-3 mt-3">Los principios con los que nos regimos</h3>
                    </b-col>
                    <div class="col-1-5">
                        <img class="img-fluid" src="../assets/conocenos/determinacion.png" alt="valores">
                        <p><span>Determinación.</span> Hacemos lo que decimos, enfocados, firmes y decisivos.</p>
                    </div>
                    <div class="col-1-5">
                        <img class="img-fluid" src="../assets/conocenos/fugalidad.png" alt="valores">
                        <p><span>Frugalidiad.</span> Maximizamos recursos, a través de gasto dirigido.</p>
                    </div>
                    <div class="col-1-5">
                        <img class="img-fluid" src="../assets/conocenos/abandono.png" alt="valores">
                        <p><span>Abandono.</span> Eliminamos lo que no genera valor, con apertura al cambio.</p>
                    </div>
                    <div class="col-1-5">
                        <img class="img-fluid" src="../assets/conocenos/colaboracion.png" alt="valores">
                        <p><span>Colaboración.</span> Trabajo colaborativo, con apoyo irrestricto e integral.</p>
                    </div>
                    <div class="col-1-5">
                        <img class="img-fluid" src="../assets/conocenos/expectativas.png" alt="valores">
                        <p><span>Exceder expectativas.</span> Damos más de lo esperado, con mejora continua</p>
                    </div>
                </b-row>
            </b-container>
        </div>

        <div class="text-center">
            <p>Hemos trabajado con las mejores empresas</p>
        </div>
        <Slide/>
        <div class="history">
            <b-container>
                <b-row>
                    <b-col md="5">
                        <span class="hightlight">Nuestra historia</span>
                        <h3 class="mb-3 mt-3">Una historia de pasión y dedicación.</h3>
                    </b-col>
                    <b-col md="7">
                        <p>En el corazón de Ctrendy late una historia de pasión y dedicación. Desde nuestros comienzos, hemos crecido con la firme convicción de hacer una diferencia.</p>
                        <p>Cada paso en nuestro viaje ha estado marcado por el deseo de llevar estilo y protección a cada persona que cruza nuestro camino. Desde entonces, hemos iluminado miradas, protegido sueños y construido relaciones que trascienden el tiempo.</p>
                    </b-col>
                </b-row>
                <b-row class="col-numbers text-center">
                    <b-col class="mb-3" md="3">
                        <h2>32+</h2>
                        <p>Sucursales</p>
                    </b-col>
                    <b-col class="mb-3" md="3">
                        <h2>35+</h2>
                        <p>Años de experiencia</p>
                    </b-col>
                    <b-col class="mb-3" md="3">
                        <h2>120+</h2>
                        <p>Colaboradores</p>
                    </b-col>
                    <b-col class="mb-3" md="3">
                        <h2>16,000+</h2>
                        <p>Puntos de venta</p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="philosophy">
            <b-container>
                <b-row>
                    <b-col md="6" class="align-self-center">
                        <span class="hightlight">Nuestra filosofía</span>
                        <h3 class="mb-3 mt-3">Creemos en un sueño compartido
                            hacia la excelencia.</h3>
                            <p>Donde el crecimiento y la compensación justa del equipo son prioritarios, por lo que la selección cuidadosa del talento es clave. Mantenemos un enfoque en la mejora continua y la satisfacción del cliente.</p>
                            <p>Nos consideramos propietarios de nuestro destino, guiados por la sencillez y la responsabilidad; por la integridad y coherencia. Lideramos con nuestro ejemplo. Valoramos la honestidad, el trabajo arduo, la calidad y la consistencia como pilares fundamentales.</p>
                    </b-col>
                    <b-col md="6" class="align-self-center">
                        <img class="img-fluid" src="../assets/conocenos/img_filosofia.png" alt="philosophy">
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="job">
            <b-container>
                <b-row class="wrapper-job">
                    <img class="icn_great" src="../assets/greatplace.png" alt="great place">
                    <b-col>
                        <img class="vector" src="../assets/conocenos/Vector5.svg" alt="">
                        <span class="hightlight-light">Bolsa de trabajo</span>
                        <h3 class="mt-3 mb-3">¡Únete a nosotros!</h3>
                        <p>Con nuestra certificación <span class="blue">Great Place to Work®</span>, estamos comprometidos con el bienestar
                            de nuestro equipo y con crear un entorno donde los sueños se conviertan en realidad.</p>
                        <router-link class="btn" :to="{ name: 'bolsatrabajo'}">Conóce más</router-link>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="mission">
            <b-container>
                <b-row>
                    <b-col md="4">
                        <span class="hightlight">Nuestra Misión y Visión</span>
                        <h3 class="mb-3 mt-3">Nos inspira ver un
                            mundo mejor.</h3>
                    </b-col>
                    <b-col md="8">
                        <p class="text-blue">Misión</p>
                        <p>Como equipo nos hemos comprometido a ser congruentes con nuestros valores, para que, a través de nuestra cultura, seamos una de las mejores compañías. Nos enorgullece ser una referencia donde es posible exceder expectativas. Con nuestro equipo de trabajo, proveedores, clientes y con nuestra comunidad. A través de un esfuerzo día a día, se hace de este, un mundo mejor.</p>
                        <p class="text-blue">Visión</p>
                        <p>Ser una empresa de clase mundial que continúe como líder nacional en la venta de lentes para el sol en las tiendas de conveniencia y autoservicio. Para 2024 lograr ser líderes en el segmento departamental y de farmacias con una venta global en el mercado superior a los 2 '100,000 (dos millones cien mil) de lentes para sol y de lectura.</p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="instalacciones">
            <b-container>
                <b-row>
                    <b-col class="text-center" md="12">
                        <span class="hightlight">Nuestras instalaciones</span>
                        <h3 class="mb-3 mt-3">Descubre el corazón de Ctrendy en nuestras instalaciones,<br> donde la pasión y la creatividad se fusionan.</h3>
                        <p>Cada espacio cuenta una historia de dedicación y excelencia, invitándote a formar parte de nuestra familia.</p>
                    </b-col>
                </b-row>
            </b-container>
            <b-container fluid>
                <b-row class="desktop">
                    <img class="img-fluid" src="../assets/conocenos/collage_conocenos.png" alt="">
                </b-row>
                <b-row class="mobile">
                    <b-col md="3">
                        <img class="img-fluid mb-3" src="../assets/conocenos/inst1.png" alt="valores">
                        <img class="img-fluid" src="../assets/conocenos/inst2.png" alt="valores">
                    </b-col>
                    <b-col md="3">
                        <img class="img-fluid" src="../assets/conocenos/inst3.png" alt="valores">
                    </b-col>
                    <b-col md="3">
                        <img class="img-fluid" src="../assets/conocenos/inst4.png" alt="valores">
                    </b-col>
                    <b-col md="3">
                        <img class="img-fluid mb-3" src="../assets/conocenos/inst5.png" alt="valores">
                        <img class="img-fluid" src="../assets/conocenos/inst6.png" alt="valores">
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="section5">
            <b-container>
                <b-row class="everest-wrapper">
                    <b-col class="align-self-center" md="6">
                        <img class="img-fluid mb-3" src="../assets/inicio/everest.png" alt="everest img">
                    </b-col>
                    <b-col class="align-self-center" md="6">
                        <h3> <img class="vector" src="../assets/conocenos/Vector5.svg" alt=""> Everest el techo del mundo</h3>
                        <p>Descubre cómo nuestro visionario y fundador aplicó la filosofía de Ctrendy para alcanzar la cima del Everest, inspirando perseverancia, integridad y excelencia en cada paso.</p>
                        <a href="libro-everest.pdf" target="_blank" class="btn btn-download">Leer libro</a>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Menu from '../components/Menu.vue'
    import Footer from '../components/Footer.vue'
    import Slide from '../components/SlideBrands.vue'
    export default {
        name: 'about',
        components: {
            Menu,
            Footer,
            Slide
        }
    }
</script>

<style scoped>
h3{
  font-size: 35px;
  font-weight: 400;
}
p{
    font-size: 20px;
    line-height: 25px;
}

.col-1-5{
    width: 20%;
}

/* BANNER */
.banner{
    padding-top: 250px;
    padding-bottom: 70px;
    text-align: center;
}
video{
    width: 100%;
    max-width: 1000px;
    border-radius: 10px;
}

/* VALORES */
.valores{
    padding-bottom: 100px;
}
.valores p{
    font-size: 16px;
    text-align: center;
}
.valores span{
    color: #386DE7;
}
.valores img{
    width: 100%;
    margin-bottom: 25px;
    margin-top: 15px;
}

/* HISTORIA */
.history{
    padding: 100px 0;
    max-width: 1043px;
    margin-left: auto;
    margin-right: auto; 
}
.history p{
    text-align: justify;
}
.col-numbers{
    max-width: 1004px;
    margin:auto;
    margin-top: 100px;
}
.col-numbers h2{
    color: #FC5300;
    font-size: 45px;
    font-weight: 600;
}
.col-numbers p{
    font-size: 18px;
    text-align: center;
}

/* FILOSOFIA */
.philosophy p{
    text-align: justify;
}

/* INSTALACION */
.instalacciones img{
    margin-bottom: 5px;
    width: 100%;
}
.mobile{
    display: none;
}
.desktop{
    display: block;
    padding:0;
}
.desktop img{
    width: 100%;
    padding: 0;
}
/* .instalacciones .col-md-3{
    padding: 0;
} */

/* BOLSA DE TRABAJO */
.wrapper-job{
    margin: 100px 0;
    padding: 70px 10% 100px 10%;
    color: #000;
    border-radius: 20px;
    background: #16B7C2;
    text-align: center;
    position: relative;
}
.wrapper-job .vector{
    display: block;
    width: 50px;
    margin: auto;
    margin-bottom: 15px;
}
.wrapper-job .blue{
    color: #386CE7;
}
.hightlight-light{
    color: #000;
    background: #FC53001A;
}
.icn_great{
    position: absolute;
    width: 100px;
    top: 0;
    right: 10%;
}
.wrapper-job .btn{
    color: #fff !important;
    background: #386CE7 !important;
    font-size: 25px;
    margin-top: 20px;
    width: 285px;
}
.wrapper-job .btn:focus,
.wrapper-job .btn:hover{
    color: #202020 !important;
    background: #02FFF5 !important;
}


/* MISSION VISION */
.mission{
    margin-bottom: 200px;
}
.mission p{
    text-align: justify;
}

.text-blue{
    margin-bottom: 0;
    color: #386DE7;
}

/* EVEREST */
/* SECTION 5 */
.section5{
    padding: 85px 0;
    text-align: justify;
}
.everest-wrapper{
    background:#16B7C2;
    border-radius: 20px;
    padding: 70px 7%;
    color: #fff;
}
.everest-wrapper .vector{
    width: 30px;
}
.btn-download{
    background: #FC5300 !important;
    color: #202020 !important;
    font-size: 25px;
    padding: 10px;
    width: 100%;
    max-width: 285px;
    border: none;
}
.btn-download:hover,
.btn-download:focus,
.btn-download:active{
    background: #02FFF5 !important;
    color: #202020 !important;
}

@media (max-width: 768px){
    h3{
        font-size: 27px;
        line-height: 1;
        font-weight: 400;
    }
    p{
        font-size: 18px;
        line-height: 20px;
    }
    .col-1-5{
        width: 50%;
    }

    /* BANNER */
    .banner{
        padding-top: 150px;
        padding-left: 7%;
        padding-right: 7%;
    }
    video{
        width: 100%;
        max-width: 1000px;
        border-radius: 10px;
    }

    /* VALORES */
    .valores{
        padding-bottom: 100px;
        padding-left: 7%;
        padding-right: 7%;
    }
    
    /* HISTORIA */
    .history{
        padding: 100px 7%;
        max-width: 1043px;
        margin-left: auto;
        margin-right: auto; 
    }
    .history p{
        text-align: justify;
    }
    .col-numbers{
        max-width: 1004px;
        margin:auto;
        margin-top: 100px;
    }
    .col-numbers h2{
        color: #386DE7;
        font-size: 45px;
        font-weight: 600;
    }
    .col-numbers p{
        font-size: 18px;
        text-align: center;
    }

    /* FILOSOFIA */
    .philosophy{
        padding: 0 7%;
    }

    /* INSTALACION */
    .instalacciones{
        padding: 0 7%;
    }
    .instalacciones img{
        border-radius: 20px;
    }
    .mobile{
        display: block;
    }
    .desktop{
        display: none;
    }

    /* BOLSA DE TRABAJO */
    
    .icn_great{
        position: absolute;
        width: 80px;
        top: 0;
        right: 10%;
    }
    .wrapper-job .btn{
        font-size: 20px;
    }



    /* MISSION VISION */
    .mission{
        margin-bottom: 100px;
        padding: 0 7%;
    }

    /* EVEREST */
    /* SECTION 5 */
    .section5{
        padding: 85px 7%;
        text-align: justify;
    }
    .everest-wrapper{
        background: #386CE7;
        border-radius: 20px;
        padding: 70px 7%;
        color: #fff;
    }
    .everest-wrapper .vector{
        width: 30px;
    }
    .btn-download{
        font-size: 20px;
    }
}
</style>